import { jsxs as c, jsx as s } from "react/jsx-runtime";
import { memo as _ } from "react";
import b from "../../icons/ArrowRight.js";
const p = "forma-ui__breadcrumbs__list", d = "forma-ui__breadcrumbs__item", f = "forma-ui__breadcrumbs__text", x = "forma-ui__breadcrumbs__icon", h = "forma-ui__breadcrumbs__input", t = {
  list: p,
  item: d,
  text: f,
  icon: x,
  input: h
}, y = _(({ items: r, placeholder: m, value: n, onChange: e }) => !r || !r.length ? null : /* @__PURE__ */ c("ul", { className: t.list, children: [
  r.map(({ name: i, href: o, to: u, as: l = "span" }, a) => /* @__PURE__ */ c("li", { className: t.item, children: [
    /* @__PURE__ */ s(l, { className: t.text, href: o, to: u, children: i }),
    (a < r.length - 1 || e) && /* @__PURE__ */ s(b, { className: t.icon })
  ] }, a)),
  e && /* @__PURE__ */ s("li", { children: /* @__PURE__ */ s(
    "input",
    {
      id: "breadcrumbs_input",
      type: "text",
      className: t.input,
      value: n,
      placeholder: m,
      onChange: (i) => e(i.target.value)
    }
  ) })
] }));
export {
  y as default
};
